import clsx from 'clsx';
import { ReactNode } from 'react';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import { Link } from '~components/generic/elements/Link/Link';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

const ModuleTeasersItem = ({
  data,
  uploadFileAction,
  editing,
  className,
  onChange,
  isEditing,
  entityDef,
}: IEntityComponentProps) => {
  if (!data) {
    return null;
  }

  const clsModule = clsx({ ...className.module }, 'u-bg-white-light u-full-height u-relative');
  const clsEditor = {
    'u-margin-top-sm': true,
    'o-field-text': true,
  };

  const imageId = getRelatedEntityIds(data, 'field_image')[0];
  const linkId: string = data.attributes.field_link_internal;
  const linkUrl: string = data.attributes.field_link_external?.uri;
  const linkText: string = data.attributes.field_link_text;
  const hasLink = linkId || linkUrl;
  const fieldHideTitle = data.attributes.field_hide_title;
  const fieldTitleValue = data.attributes.field_title?.value || '';
  const fieldTextValue: string = data.attributes.field_text?.value || '';

  const wrapperLink = (children: ReactNode) =>
    editing || !hasLink ? (
      <span className="c-teaser-image__link">{children}</span>
    ) : (
      <Link className="c-teaser-image__link" id={linkId} url={linkUrl}>
        {children}
      </Link>
    );

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      {wrapperLink(
        <span>
          <EditablePictureContainer
            entityType={data.type}
            fieldName="relationships.field_image"
            entityId={imageId}
            editing={editing}
            proportions="4:3"
            onChangeImage={onChange}
            onUpload={uploadFileAction}
            placeholder={isEditing && entityDef.fields['relationships.field_image'].options.placeholder}
          />
          <div className="teaser-content">
            {(!fieldHideTitle && isEditing && fieldTitleValue !== '') ||
            (!isEditing && !fieldHideTitle && fieldTitleValue !== '<p><br></p>') ? (
              <EditableField
                hide={fieldHideTitle}
                entityType={data.type}
                fieldName="attributes.field_title.value"
                data={fieldTitleValue}
                editing={editing}
                onChange={onChange}
              />
            ) : null}
            {isEditing || fieldTextValue !== '<p><br></p>' ? (
              <EditableField
                entityType={data.type}
                className={clsEditor}
                fieldName="attributes.field_text.value"
                data={fieldTextValue}
                editing={editing}
                onChange={onChange}
              />
            ) : null}
            {!!linkText && (
              <span className="c-icon-custom-after c-icon-big c-icon-custom-after--arrow-right  c-button c-button--light u-margin-top-lg c-teaser__button">
                {linkText}
              </span>
            )}
          </div>
        </span>,
      )}
    </div>
  );
};

export default ModuleTeasersItem;
